import { Button, Col, Divider, Form, Input, Row, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Modal from "antd/lib/modal/Modal";
import React, { Key, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppraisalSectionProps } from ".";
import { VALIDATION_MESSAGE_CONFIG } from "../../../../../../constants/constants";
import { ResourceModel } from "../../../../../../models/resources.model";
import { ClientService } from "../../../../../../services/client.service";
import { AMOUNT_UTIL } from "../../../../../../utils/amount.utils";
import { VALIDATION_UTIL } from "../../../../../../utils/validation.utils";
import AmountInput from "../../../../../atoms/amount-input";
import { DropdownIcon, InfoCircleIcon, MinusIcon, PlusIcon } from "../../../../../atoms/icon";

const { Option } = Select;


const BreackDownSection = (props: AppraisalSectionProps) => {

    const { t } = useTranslation();
    const [benefitTypes, setBenefitTypes] = useState<ResourceModel[]>([]);
    const [modalVisible, setModalVisible] = useState(false);

    const [form] = Form.useForm();

    const addNew = () => {
        form.resetFields();
        setModalVisible(true);
    }

    const save = () => {
        form.submit();
    }

    const modalSubmit = (values: any) => {
        ClientService.createBenefitTypes(values).then(res => {
            setBenefitTypes(pre => [...pre, res.data]);
            setModalVisible(false);
        })
    }

    useEffect(() => {
        ClientService.getBenefitTypes().then(res => {
            setBenefitTypes(res.data);
        });
    }, [])

    return (
        <div className="section-wrapper">
            <p className="blue-text description">{t("Appraisal.breackdownDes")}</p>
            <Form.List
                name="breakdown_of_funding_and_benefits"
            >
                {(fields, { add, remove }, { errors }) => (
                    <div className="form-list">
                        {fields.map((field, index) => (
                            <div className="form-list-item-wrapper" key={field.key} >
                                <Form.Item
                                    name={[field.name, "id"]}
                                    fieldKey={[field.fieldKey as Key, "id"]}
                                    hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name={[field.name, "breakdown_of_funding_and_benefit_type_id"]}
                                    fieldKey={[field.fieldKey as Key, "breakdown_of_funding_and_benefit_type_id"]}
                                    initialValue={benefitTypes && benefitTypes.length ? benefitTypes[0].id : 1}
                                    noStyle>
                                    <Select
                                        suffixIcon={<DropdownIcon />}
                                        bordered={false}
                                        dropdownStyle={{ minWidth: "200px" }}
                                        dropdownRender={menu => (
                                            <div>
                                                {menu}
                                                <Divider style={{ margin: '30px 10px 5px' }} />
                                                <Button className="primary-text" type="text" onClick={addNew}>
                                                    + {t("ScenarioMitigation.btnNewEntry")}
                                                </Button>
                                            </div>
                                        )}>
                                        {
                                            benefitTypes && benefitTypes.map((item, index) => (
                                                <Option key={index} value={item.id}> {item.name} </Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>

                                <Form.List
                                    name={[field.name, "details"]}
                                    initialValue={[{}]}
                                >

                                    {(details, { add, remove }, { errors }) => (
                                        <>
                                            {details.map((f, i) => (

                                                <Form.Item
                                                    className="form-list-item"
                                                    key={f.key}
                                                >
                                                    <Form.Item
                                                        name={[f.name, "id"]}
                                                        fieldKey={[f.fieldKey as Key, "id"]}
                                                        hidden
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Row gutter={16} className="flex-1">
                                                        <Col span={16}>
                                                            <Form.Item
                                                                name={[f.name, "description"]}
                                                                fieldKey={[f.fieldKey as Key, "description"]}
                                                                rules={props.breakdown_of_funding_and_benefits?.min_element && 
                                                                    props.breakdown_of_funding_and_benefits?.min_element - index >= 1 &&
                                                                    props.breakdown_of_funding_and_benefits.details &&  
                                                                    props.breakdown_of_funding_and_benefits.details.min_element && 
                                                                    props.breakdown_of_funding_and_benefits.details.min_element - i >= 1? 
                                                                    VALIDATION_UTIL.getRulesValidationField("description", props.breakdown_of_funding_and_benefits.details.required_fields) : undefined}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item
                                                                name={[f.name, "value"]}
                                                                fieldKey={[f.fieldKey as Key, "value"]}
                                                                rules={props.breakdown_of_funding_and_benefits?.min_element && 
                                                                    props.breakdown_of_funding_and_benefits?.min_element - index >= 1 &&
                                                                    props.breakdown_of_funding_and_benefits.details &&  
                                                                    props.breakdown_of_funding_and_benefits.details.min_element && 
                                                                    props.breakdown_of_funding_and_benefits.details.min_element - i >= 1? 
                                                                    VALIDATION_UTIL.getRulesValidationField("value", props.breakdown_of_funding_and_benefits.details.required_fields) : undefined}
                                                            >
                                                                <AmountInput placeholder={t("Appraisal.lbValue")} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>


                                                    <span className="form-list-action">
                                                        <PlusIcon onClick={() => add()} />
                                                    </span>
                                                    <span className="form-list-action">
                                                        {
                                                            i > 0 && <MinusIcon onClick={() => { remove(field.name) }} />
                                                        }
                                                    </span>
                                                </Form.Item>
                                            ))}
                                        </>
                                    )}
                                </Form.List>

                                <Form.Item
                                    fieldKey={[field.fieldKey as Key, "notes"]}
                                    name={[field.name, "notes"]}
                                    rules={props.breakdown_of_funding_and_benefits?.min_element && 
                                        props.breakdown_of_funding_and_benefits?.min_element - index >= 1 ? 
                                        VALIDATION_UTIL.getRulesValidationField("notes", props.breakdown_of_funding_and_benefits.required_fields) : undefined}
                                    >
                                    <TextArea rows={5} placeholder={t("Global.lbAddNoteHere")} />
                                </Form.Item>
                            </div>

                        ))}

                        <Form.Item>
                            <Button className="bg-gray" type="default" shape="round" onClick={() => add()}>
                                {t("Scenario.btnAddMore")}
                            </Button>
                        </Form.Item>

                    </div>
                )}
            </Form.List>

            <Row gutter={[16, 32]}>
                <Col span={16} className="total-text">
                    {t("Appraisal.lbNetCashInflow")}
                </Col>
                <Col span={8} className="green-text">
                    {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.annual_total)}
                </Col>
            </Row>

            <Row gutter={[16, 32]} className="end-ss">
                <Col span={16} className="total-text">
                    {t("Appraisal.lbNetCashOutflow")}
                </Col>
                <Col span={8} className="red-text">
                    {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.annual_total)}
                </Col>
            </Row>

            <Modal
                title={t("ScenarioMitigation.lbNewEntry")}
                className="control-effec-modal"
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={<Button htmlType="submit" type="primary" shape="round" onClick={save}>
                    {t("ScenarioMitigation.btnSaveAdd")}
                </Button>}>
                <Form
                    className="modal-form"
                    layout='vertical'
                    onFinish={modalSubmit}
                    form={form}
                    validateMessages={VALIDATION_MESSAGE_CONFIG}>
                    <Form.Item
                        name="name"
                        label={t("Appraisal.lbTypeName")}
                        tooltip={{ title: t("Appraisal.lbTypeName"), icon: <InfoCircleIcon /> }}
                        rules={[{ required: true }]}>
                        <input className="ant-input" />
                    </Form.Item>
                </Form>

            </Modal>

        </div >
    )
}

export default BreackDownSection;